module.exports = __webpack_public_path__ + "static/spine-right-df890432e6d147d2a361969ff93ea6a6.jpg";